import { default as _91id_93mHUnIROFxTMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/appointment/[id].vue?macro=true";
import { default as appointmentG3PqpJVKnhMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/appointment.vue?macro=true";
import { default as _91id_9372dx9MyuFeMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/event/[id].vue?macro=true";
import { default as eventArYiZYUk1AMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/event.vue?macro=true";
import { default as eventIFrameapNdNP9p79Meta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFrame.vue?macro=true";
import { default as eventIFramePreviewPnsBMCTaKBMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFramePreview.vue?macro=true";
import { default as eventIFrameTestKUzvZwxtIjMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFrameTest.vue?macro=true";
import { default as indexCYCc8pXdmJMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/index.vue?macro=true";
import { default as _91registration_93Ri4ktfjhByMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/overview/[registration].vue?macro=true";
import { default as overviewdDc6eAO40jMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/overview.vue?macro=true";
import { default as participantsj4IdqNz9fiMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/participants.vue?macro=true";
import { default as participantsDetails1iLdKfUB6NMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/participantsDetails.vue?macro=true";
import { default as paymentxg2ZCTju4aMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/payment.vue?macro=true";
import { default as registrationDetailsHKvmcqckYnMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/registrationDetails.vue?macro=true";
import { default as regStartkz5zcwAfxvMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/regStart.vue?macro=true";
import { default as regSummaryDBP0KYSOPjMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/regSummary.vue?macro=true";
import { default as _91id_938BWDNXueEmMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id].vue?macro=true";
import { default as registrationCm5WqhWSIPMeta } from "/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration.vue?macro=true";
export default [
  {
    name: "appointment___de",
    path: "/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___de",
    path: "/termin/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "appointment___en",
    path: "/en/appointment",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/appointment.vue").then(m => m.default || m),
    children: [
  {
    name: "appointment-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/appointment/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___de",
    path: "/event",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___de",
    path: "/veranstaltung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "event___en",
    path: "/en/event",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/event.vue").then(m => m.default || m),
    children: [
  {
    name: "event-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/event/[id].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "eventIFrame___de",
    path: "/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrame___en",
    path: "/en/eventIFrame",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFrame.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___de",
    path: "/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFramePreview___en",
    path: "/en/eventIFramePreview",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFramePreview.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___de",
    path: "/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "eventIFrameTest___en",
    path: "/en/eventIFrameTest",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/eventIFrameTest.vue").then(m => m.default || m)
  },
  {
    name: "index___de",
    path: "/",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "overview___de",
    path: "/overview",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___de",
    path: "/uebersicht/:registration()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "overview___en",
    path: "/en/overview",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/overview.vue").then(m => m.default || m),
    children: [
  {
    name: "overview-registration___en",
    path: ":registration()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/overview/[registration].vue").then(m => m.default || m)
  }
]
  },
  {
    name: "registration___de",
    path: "/registration",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___de",
    path: "/anmeldung/:id()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___de",
    path: "teilnehmer",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___de",
    path: "teilnehmerDetails",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___de",
    path: "zahlung",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___de",
    path: "anmeldungsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___de",
    path: "start",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___de",
    path: "zusammenfassung",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  },
  {
    name: "registration___en",
    path: "/en/registration",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration.vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id___en",
    path: ":id()",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id].vue").then(m => m.default || m),
    children: [
  {
    name: "registration-id-participants___en",
    path: "/en/registration/participants",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/participants.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-participantsDetails___en",
    path: "/en/registration/participantsDetails",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/participantsDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-payment___en",
    path: "/en/registration/payment",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/payment.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-registrationDetails___en",
    path: "/en/registration/registrationDetails",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/registrationDetails.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regStart___en",
    path: "/en/registration/start",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/regStart.vue").then(m => m.default || m)
  },
  {
    name: "registration-id-regSummary___en",
    path: "/en/registration/summary",
    component: () => import("/home/forge/amosweb.de/releases/20251006114752/registration/pages/registration/[id]/regSummary.vue").then(m => m.default || m)
  }
]
  }
]
  }
]